// Component modes
export enum ConditionsModalMode {
	CREATE = "CREATE",
	READ = "READ",
}
